import { render, staticRenderFns } from "./CloseModal.vue?vue&type=template&id=bd711970&"
import script from "./CloseModal.vue?vue&type=script&lang=ts&"
export * from "./CloseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports